<template>
  <b-overlay v-if="showLoaderOverlay" no-wrap fixed :z-index="10000" :show="true" rounded="sm">
    <template v-slot:overlay>
      <h3>Traitement en cours, veuillez patienter.</h3>
      <appLoader />
    </template>
  </b-overlay>
</template>

<script>
export default {
  name: "LoaderOverlay",
  computed: {
    // general overlay loader
    showLoaderOverlay() {
      return this.$store.state.showLoaderOverlay;
    },
  },
};
</script>
